import { render, staticRenderFns } from "./safety.vue?vue&type=template&id=0bd671ad&scoped=true"
import script from "./safety.vue?vue&type=script&lang=ts"
export * from "./safety.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd671ad",
  null
  
)

export default component.exports